import {Action, Reducer} from "redux";

import {IChatState} from "./state/ChatState";
import {initChatState} from "./state/InitChatState";

import { START_SIGNALR, ADD_MESSAGE_TO_STATE_SUCCESS, ADD_MESSAGES_TO_STATE_SUCCESS, EDIT_MESSAGE_SUCCESS, EDIT_MESSAGE_START, INITIALIZE_MESSAGES_SUCCESS, READ_MESSAGE, SEND_FILE_MESSAGE_START_ACTION, SEND_FILE_MESSAGE_FINISH_ACTION, SET_FOOTER_COMPANY_TITLE_SUCCESS, INIT_CLIENT_HIDE_START_MESSAGE_SUCCESS, SEND_MESSAGE_ACTION_START, SEND_MESSAGE_ACTION_SUCCESS, SEND_MESSAGE_ACTION_ERROR, TRY_GET_PREV_CHAT_START, TRY_GET_PREV_CHAT_FINISH, RESET_CHAT} from "./actions/types";
import { StartSignalRAction, AddMessageToStateSuccessAction, AddMessagesToStateSuccessAction, EditMessageSuccessAction, InitializeMessagesSuccessAction, ReadMessageAction, SetFooterCompanyTitleSuccessAction, InitHideClientStartMessageSuccessAction, SendMessageAction, SendMessageActionSuccess, SendMessageActionStart, ResetChatAction} from "./actions/interfaces";
import { IMessage } from "./models/messages/Message";
import { startSignalRConnection } from "src/~signalR/SignalRHub"


export const chatReducer: Reducer<IChatState> = (state: IChatState = initChatState, incomingAction: Action): IChatState => {
    const action = incomingAction;

    switch (action.type) {

        case ADD_MESSAGE_TO_STATE_SUCCESS: {
            const msg = (action as AddMessageToStateSuccessAction).payload.message;
            msg.isRead = false;
            const messages = msg.needClearMessagesHistory ? [msg] : state.messages.concat(msg);

            return {
                ...state,
                messages
            }
        }


        case ADD_MESSAGES_TO_STATE_SUCCESS: {
            const msgs = (action as AddMessagesToStateSuccessAction).payload.messages;
            for(const message of msgs) {
                message.isRead = false;
            }

            const incomingMessagesId = msgs.map(m => m.externalId);

            const messages = state.messages.filter(m => !incomingMessagesId.includes(m.externalId)).concat(msgs);

            return {
                ...state,
                messages
            }
        }

        case TRY_GET_PREV_CHAT_START: {
            return {
                ...state,
                isGettingPrevChatMessages: true
            }
        }

        case TRY_GET_PREV_CHAT_FINISH: {
            return {
                ...state,
                isGettingPrevChatMessages: false
            }
        }

        case INITIALIZE_MESSAGES_SUCCESS: {
            const { messages, customerId, loadPrevChat } = (action as InitializeMessagesSuccessAction).payload;
            
            return {
                ...state,
                messages,
                customerId,
                loadPrevChat
            }
        }

        case START_SIGNALR: {
            const hubConnection = state.hubConnection;

            hubConnection.off('SignalRMessage');
            hubConnection.on('SignalRMessage', (receivedMessage) => {
                (action as StartSignalRAction).payload.onSignalRMessageReceived(receivedMessage);
            });

            startSignalRConnection(hubConnection);

            return {
                ...state,
                hubConnection
            }
        }
        case EDIT_MESSAGE_START: {
            return {
                ...state,
                isMessageEditing: true,
            }
        }
        case EDIT_MESSAGE_SUCCESS: {
            const { message } = (action as EditMessageSuccessAction).payload;
            const messages: IMessage[] = state.messages;

            const messageToEdit = messages.find(m => m.externalId == message.externalId);
            if(messageToEdit) {
                messageToEdit.text = message.text
                messageToEdit.imageId = message.imageId
                messageToEdit.fileId = message.fileId 
                messageToEdit.file = message.file
                messageToEdit.contentType = message.contentType
            }
            
            
            return {
                ...state,
                messages,
                isMessageEditing: false
            }
        }

        case READ_MESSAGE: {
            const { messages } = state;
            const { messageExternalId } = (action as ReadMessageAction).payload;

            for (const message of messages) {
                if (message.externalId === messageExternalId) {
                    message.isRead = true;
                }
            }

            return {
                ...state,
                messages,
            }
        }

        case SEND_MESSAGE_ACTION_START: {
            const { message } = (action as SendMessageActionStart).payload;

            return {
                ...state,
                sendingMessage: message
            }
        }

        case SEND_MESSAGE_ACTION_SUCCESS: {

            return {
                ...state,
                sendingMessage: null
            }
        }

        case SEND_MESSAGE_ACTION_ERROR: {
            const sm = state.sendingMessage ? {...state.sendingMessage, failed: true } : state.sendingMessage;

            return {
                ...state,
                sendingMessage: sm
            }
        }

        case SEND_FILE_MESSAGE_START_ACTION: {
            return {
                ...state,
                sendingFilesCount: state.sendingFilesCount + 1
            }
        }

        case SEND_FILE_MESSAGE_FINISH_ACTION: {
            return {
                ...state,
                sendingFilesCount: state.sendingFilesCount - 1
            }
        }

        case INIT_CLIENT_HIDE_START_MESSAGE_SUCCESS: {
            const { hideClientStartMessage } = (action as InitHideClientStartMessageSuccessAction).payload;
            return {
                ...state,
                hideClientStartMessage
            }
        }

        case SET_FOOTER_COMPANY_TITLE_SUCCESS: {
            const { footerCompanyName, footerCompanyUrl } = (action as SetFooterCompanyTitleSuccessAction).payload;
            return {
                ...state,
                footerCompanyName,
                footerCompanyUrl
            }
        }

        case RESET_CHAT: {
            return {
                ...state,
                messages: [],
                customerId: "",
                isGettingPrevChatMessages: false,
                sendingFilesCount: 0,
                sendingMessage: null,
                hideClientStartMessage: false,
                loadPrevChat: false,
            }
        }
        default:
            return state;
    }
};
